import { useState, useRef } from "react";
import "./SearchWithFilter.css";
import { CircleButton } from "../common/CircleButton/circle-button";
import { DropdownPortal } from "../common/DropdownPortal";

type SearchWithFilterProps = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
  categories: string[];
  showAddButton?: boolean;
  placeHolderText?: string;
  allCategoriesOptionLabel?: string;
  handleAddClick: () => void;
};

export const SearchWithFilter = ({
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  categories,
  showAddButton,
  placeHolderText,
  allCategoriesOptionLabel,
  handleAddClick,
}: SearchWithFilterProps) => {
  const [showCategoryFilter, setShowCategoryFilter] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const filterButtonRef = useRef<HTMLDivElement>(null);

  const handleFilterClick = () => {
    if (filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 4,
        left: rect.right - 200,
      });
    }
    setShowCategoryFilter(!showCategoryFilter);
  };

  const handleCategorySelect = (category: string | null) => {
    setSelectedCategory(category);
    setShowCategoryFilter(false);
  };

  return (
    <>
      <div className="search-container">
        <div className="search-bar-with-filter">
          <input
            type="text"
            placeholder={placeHolderText}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <div ref={filterButtonRef}>
            <CircleButton
              onClick={handleFilterClick}
              iconKey="filter"
              buttonStyle={selectedCategory ? "primary" : "default"}
              ariaLabel="Filter by category"
            />
          </div>
        </div>
        {showAddButton && (
          <div style={{ marginLeft: "8px" }}>
            <CircleButton
              onClick={handleAddClick}
              iconKey="add"
              buttonStyle="primary"
            />
          </div>
        )}
      </div>

      {showCategoryFilter && (
        <DropdownPortal
          position={dropdownPosition}
          onClose={() => setShowCategoryFilter(false)}
          className="category-filter-dropdown"
          minWidth={200}
        >
          <ul className="dropdown-portal__list">
            <li>
              <button
                className={`dropdown-portal__option ${!selectedCategory ? "active" : ""}`}
                onClick={() => handleCategorySelect(null)}
              >
                {allCategoriesOptionLabel || "All"}
              </button>
            </li>
            {categories.map((categoryKey) => (
              <li key={categoryKey}>
                <button
                  className={`dropdown-portal__option ${selectedCategory === categoryKey ? "active" : ""}`}
                  onClick={() => handleCategorySelect(categoryKey)}
                >
                  {categoryKey}
                </button>
              </li>
            ))}
          </ul>
        </DropdownPortal>
      )}
    </>
  );
};
